<template>
    <vx-box class="p-4 flex items-center gap-4">
        <div class="grow">
            <div class="flex items-center line-clamp-1 font-bold gap-2">
                <vx-popover placement="top" class="h-5" arrow>
                    <span
                        class="transition cursor-pointer inline-block size-3.5 rounded-[3px]"
                        :class="CATEGORY_COLORS[props.category.color].bg"
                    ></span>
                    <template v-slot:content="{ close }">
                        <div class="flex gap-2">
                            <div
                                v-for="[key, color] of Object.entries(CATEGORY_COLORS)"
                                :key="key"
                                :class="[
                                    'cursor-pointer hover:scale-110 active:scale-90 rounded size-10 transition ring-2 ring-offset-2',
                                    color.bg,
                                    props.category.color === key ? color.ring : 'ring-transparent',
                                ]"
                                @click="
                                    close();
                                    updateCategory(props.category.id, { color: key as IntelligentCategoryColor });
                                "
                            ></div>
                        </div>
                    </template>
                </vx-popover>
                {{ props.category.displayName }}
            </div>
            <div class="text-sm text-slate-500 line-clamp-2">
                {{ props.category.classificationHints }}
            </div>
            <div v-if="props.category.description" class="text-xs text-slate-500">
                {{ props.category.description }}
            </div>
        </div>
        <vx-button outline color="muted" @click="emit('edit', props.category)">
            Edit <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
        </vx-button>
        <vx-button outline color="muted" @click="emit('delete', props.category)">
            <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
        </vx-button>
    </vx-box>
</template>

<script lang="ts" setup>
import { faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxPopover } from '@voxie/frontend-components';
import { useIntelligentInbox, CATEGORY_COLORS } from './useIntelligentInbox';
import type { IntelligentCategory, IntelligentCategoryColor } from './useIntelligentInbox';

const props = defineProps<{
    category: IntelligentCategory;
}>();

const emit = defineEmits<{
    edit: [category: IntelligentCategory];
    delete: [category: IntelligentCategory];
}>();

const { updateCategory } = useIntelligentInbox();
</script>
